import { JSONSchemaType } from 'ajv'

export interface ICertificateFormData {
  certificate: string
  password: string
  acceptance: boolean
}

const CertificateSchema: JSONSchemaType<ICertificateFormData> = {
  type: 'object',
  additionalProperties: false,
  properties: {
    certificate: {
      type: 'string',
      minLength: 1,
      errorMessage: 'O Certificado é obrigatório',
    },
    password: {
      type: 'string',
      minLength: 1,
      errorMessage: 'A Senha é obrigatória',
    },
    acceptance: {
      type: 'boolean',
      errorMessage: 'Você deve aceitar os termos!',
    },
  },
  required: ['certificate', 'password', 'acceptance'],
}

export default CertificateSchema
